import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Radio,
} from "antd";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import { loadProduct } from "../../redux/actions/product/getAllProductAction";
// import { addSale } from "../../redux/actions/sale/addSaleAction";
import { editSale } from "../../redux/actions/sale/editSaleAction";
import Products from "./Products";

import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadAllStaff } from "../../redux/actions/user/getStaffAction";
import { loadAllSale } from "../../redux/actions/sale/getSaleAction";
import { loadSingleSale } from "../../redux/actions/sale/detailSaleAction";
import {
  confirmMasterListPriceSyncThen,
  getReferenceListPriceFromProduct,
} from "../../utils/productListPriceSync";
import "./sale.css";

const { Title } = Typography;

const EditSale = ({ invoiceId }) => {


  
  const { Option } = Select;
  const [formData, setFormData] = useState({});
  const [productFormData, setProductFormData] = useState({
    saleInvoiceProduct: [],
  });
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  const onClickLoading = () => {
    setLoader(true);
  };

  const [date, setDate] = useState(moment());
  const allSales = useSelector((state) => state.sales.list);

  let invoiceN = allSales && allSales.length > 0 ? Math.max(...allSales.map((o) => o.id)) : 0;
  const [invoiceNum, setInvoiceNum] = useState(invoiceN + 1);
  const [preInvoiceText, setPreInvoiceText] = useState("INV/25-26/");
  const [discountType, setDiscountType] = useState("item");
  const [discount, setDiscount] = useState(0);

  const [afterDiscount, setAfterDiscount] = useState(0);
  const [afterProductDiscount, setAfterProductDiscount] = useState(0);
  
  // Additional discount states
  const [discountAmount, setDiscountAmount] = useState(0);
  const [additionalDiscount, setAdditionalDiscount] = useState(0);
  
  // Round off states
  const [roundOffEnabled, setRoundOffEnabled] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState(0);
  
  const dispatch = useDispatch();

  const allCustomer = useSelector((state) => state.customers.list);
  const allProducts = useSelector((state) => state.products.list);
  const allCurrencies = useSelector((state) => state.productCurrencies?.list);
  const [editInvoice, setEditInvoice] = useState(null);
  const allStaff = useSelector((state) => state.users.list);

  const [customer, setCustomer] = useState(null);
  const [orderNum, setOrderNum] = useState(null);
  const [orderDate, setOrderDate] = useState(null);
  const [salesPerson, setSalesPerson] = useState(null);
  const id = useParams("id");
  const editInvoiceId = parseInt(id.id);
  const [documentType, setDocumentType] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('type') || 'sale';
  });

  // Form Function
  const [form] = Form.useForm();
  const [totalDiscountPaidDue, setTotalDiscountPaidDue] = useState({
    total: 0,
    productDiscount: 0,
    afterProductDiscount: 0,
    discount: 0,
    afterDiscount: 0,
    paid: 0,
    due: 0,
    totalQty: 0,
  });

  const getSaleDetail = useSelector((state) => state.users.list); // to get saved invoice details
  // Get the single sale invoice from detail state
  const saleDetail = useSelector((state) => state.sales.sale);
  const singleSaleInvoice = saleDetail?.singleSaleInvoice;
  
  // Retrieve the saleInvoiceProduct data from the single sale invoice
  const saleInvoiceProductData = singleSaleInvoice?.saleInvoiceProduct || 
    singleSaleInvoice?.quotationInvoiceProduct ||
    singleSaleInvoice?.challanInvoiceProduct;

  const salesList = useSelector((state) => state.sales.list);

  useEffect(() => {
    dispatch(loadProduct({ page: 1, limit: 1000 }));
  }, []);

  // Load the specific document based on type
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const docType = urlParams.get('type') || 'sale';
    setDocumentType(docType);
    // Always fetch fresh data for the correct document type
    dispatch(loadSingleSale(editInvoiceId, docType));
  }, [editInvoiceId, dispatch]); // Don't include documentType - read it fresh from URL each time

  useEffect(() => {
    dispatch(
      loadAllSale({
        page: 1,
        limit: 1000,
        startdate: moment().startOf("month"),
        // startdate: moment().month(3).startOf("month"),
        enddate: moment().endOf("month"),
        user: "",
      })
    );
  }, []);

  useEffect(() => {
    dispatch(loadAllCustomer({ page: 1, limit: 100 }));
    dispatch(loadAllStaff({ status: "true" }));

    if (invoiceId) {
      setFormData({
        orderNum: invoiceId.orderNum,
        orderDate: moment(invoiceId.orderDate),
        customer_id: invoiceId.customerId,
        sales_person_id: invoiceId.salesPersonId,
        // Update other form data properties based on the invoice data
      });
    }
  }, [dispatch, invoiceId]);

  // useEffect(() => {
  // 	let editItem=allSales.find(item=>item.id==id.id);
  // 	setEditInvoice(editItem);
  // 	console.log("editItem",editItem)
  // 	console.log("product data",saleInvoiceProductData)
  // 	if (saleInvoiceProductData) {
  // 		const updatedSelectedProds = saleInvoiceProductData.map((product) => {
  // 		  const foundProd = allProducts.find((item) => item.id == product.product_id);
  // 		  console.log("foundProd",foundProd)
  // 		  return {
  // 			...foundProd,
  // 			selectedQty: product.product_quantity,
  // 			sale_disc: product.product_sale_discount,
  // 			author: foundProd.author,
  // 			publisher: foundProd.publisher,
  // 			price: foundProd.price,
  // 			quantity: foundProd.quantity,
  // 		  };
  // 		});
  // 		setSelectedProds(updatedSelectedProds);
  // 	  }
  // }, []);

  useEffect(() => {
    // IMPORTANT: Only use singleSaleInvoice if it matches BOTH the ID AND document type
    // This prevents using stale data from a different document type with the same ID
    // Read documentType directly from URL to avoid state timing issues
    const urlParams = new URLSearchParams(window.location.search);
    const currentDocType = urlParams.get('type') || 'sale';
    
    let editItem = null;
    
    // Strict check: singleSaleInvoice must match both ID and document type from URL
    const singleSaleMatches = singleSaleInvoice && 
                              singleSaleInvoice.id == editInvoiceId && 
                              (singleSaleInvoice.document_type || 'sale') === currentDocType;
    
    if (singleSaleMatches) {
      // Use singleSaleInvoice only if it matches
      editItem = singleSaleInvoice;
    } else if (allSales && Array.isArray(allSales)) {
      // Fallback: find in allSales array with strict document type matching (from URL)
      editItem = allSales.find((item) => {
        return item.id == editInvoiceId && (item.document_type || 'sale') === currentDocType;
      });
    }
    // If no match found, editItem remains null and will be set when API call completes
    
    setEditInvoice(editItem);

    // ALWAYS use product data from editItem (if it matches), never from stale singleSaleInvoice
    // This ensures we use the correct product data for the document being edited
    const productDataToUse = editItem?.saleInvoiceProduct || 
                             editItem?.quotationInvoiceProduct || 
                             editItem?.challanInvoiceProduct || 
                             null; // Don't use saleInvoiceProductData from stale singleSaleInvoice
    
    if (productDataToUse && editItem) {
      const updatedSelectedProds = productDataToUse.map((product, index) => {
        const foundProd = allProducts && Array.isArray(allProducts)
          ? allProducts.find((item) => item.id === product.product_id)
          : null;
        // Use nested product from API when not in allProducts so every row prefills
        let baseProd = foundProd || (product.product ? {
          ...product.product,
          product_currency: product.product.product_currency || {
            symbol: product.product_sale_currency,
            conversion: product.product_sale_conversion,
          },
        } : null);
        // If still no base (e.g. list API didn't include product for this line), build minimal row from line item so we never drop a row
        if (!baseProd) {
          baseProd = {
            id: product.product_id,
            name: '',
            isbn: '',
            author: '',
            book_publisher: null,
            sale_price: product.product_sale_price,
            product_currency: {
              symbol: product.product_sale_currency || '₹',
              conversion: product.product_sale_conversion ?? 1,
            },
          };
        }
        return {
          ...baseProd,
          key: index,
          selectedQty: product.product_quantity,
          sale_disc: product.product_sale_discount,
          sale_price: product.product_sale_price,
          product_currency: baseProd.product_currency || {
            symbol: product.product_sale_currency || '₹',
            conversion: product.product_sale_conversion ?? 1,
          },
          reference_list_price: getReferenceListPriceFromProduct(foundProd || baseProd),
        };
      });
      setSelectedProds(updatedSelectedProds);
    }

    if (editItem) {
      setCustomer(editItem?.customer_id);
      setSalesPerson(editItem?.user_id);
      setInvoiceNum(editItem?.invoice_number);
      setOrderDate(editItem?.invoice_order_date ? moment(editItem.invoice_order_date) : null);
      setOrderNum(editItem?.invoice_order_number);
      setDate(editItem?.date ? moment(editItem.date) : moment());
      setPreInvoiceText(editItem?.prefix || (currentDocType === 'quotation' ? 'QTN/25-26/' : currentDocType === 'challan' ? 'CHL/25-26/' : 'INV/25-26/'));

      const billDiscountAmt = Number(editItem?.discount) || 0;
      setDiscountType(billDiscountAmt > 0 ? "bill" : "item");
      
      // Pre-fill additional discount
      if (billDiscountAmt > 0) {
        setDiscountAmount(billDiscountAmt);
        setTotalDiscountPaidDue((prev) => ({
          ...prev,
          discount: billDiscountAmt,
        }));
        
        setTimeout(() => {
          const subtotal = editItem.total_amount - (editItem.total_product_discount || 0);
          if (subtotal > 0) {
            const discountPercent = (billDiscountAmt / subtotal) * 100;
            setAdditionalDiscount(discountPercent.toFixed(2));
          }
        }, 100);
      } else {
        setDiscountAmount(0);
        setAdditionalDiscount("");
        setTotalDiscountPaidDue((prev) => ({
          ...prev,
          discount: 0,
        }));
      }
      
      // Pre-fill round off
      if (editItem?.round_off_enabled) {
        setRoundOffEnabled(true);
        setRoundOffAmount(editItem.round_off_amount || 0);
      }

      // Pre-fill paid and due so Due Amount and Round Off recalculate correctly
      const paid = parseFloat(editItem?.paid_amount) || 0;
      const due = parseFloat(editItem?.due_amount) ?? 0;
      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        paid,
        due,
      }));
      // Sync form fields — API uses user_id but Form.Item name is sales_person_id (defaultValue on Select does not register with Form)
      const spId =
        editItem.user_id != null && editItem.user_id !== ""
          ? Number(editItem.user_id)
          : undefined;
      const custId =
        editItem.customer_id != null && editItem.customer_id !== ""
          ? Number(editItem.customer_id)
          : undefined;
      form.setFieldsValue({
        ...(documentType === "sale" && (paid > 0 || due >= 0) ? { paid_amount: paid } : {}),
        ...(spId != null && !Number.isNaN(spId) ? { sales_person_id: spId } : {}),
        ...(custId != null && !Number.isNaN(custId) ? { customer_id: custId } : {}),
      });
    }
  }, [singleSaleInvoice, allSales, allProducts, editInvoiceId, documentType, form]);

  // Update prefix when document type changes (but don't override if editItem has prefix)
  useEffect(() => {
    if (!editInvoice?.prefix) {
      if (documentType === 'quotation') {
        setPreInvoiceText('QTN/25-26/');
      } else if (documentType === 'challan') {
        setPreInvoiceText('CHL/25-26/');
      } else {
        setPreInvoiceText('INV/25-26/');
      }
    }
  }, [documentType, editInvoice?.prefix]);

  useEffect(() => {
    dispatch(loadAllCustomer({ page: 1, limit: 100 }));
  }, []);

  useEffect(() => {
    dispatch(loadProduct({ page: 1, limit: 1000 }));
  }, []);

  useEffect(() => {
    dispatch(loadAllStaff({ status: "true" }));
  }, []);

  const onFormSubmit = async (values) => {
    if (!values || typeof values !== "object") {
      try {
        await form.validateFields();
      } catch {
        setLoader(false);
        return;
      }
    }

    const runSave = async () => {
      const saleInvoiceProduct = selectedProds.map((prod) => {
        return {
          product_id: prod.id,
          product_quantity: prod.selectedQty,
          product_sale_price: prod.sale_price,
          product_sale_discount: prod.sale_disc,
          product_sale_currency: prod.product_currency.symbol,
          product_sale_conversion: prod.product_currency.conversion,
        };
      });

      try {
        const valueData = {
          orderNumber: orderNum,
          orderDate: orderDate,
          date: date,
          ...(documentType === "sale" && { paid_amount: totalDiscountPaidDue.paid }),
          discount: totalDiscountPaidDue.discount,
          round_off_enabled: roundOffEnabled,
          round_off_amount: roundOffAmount,
          customer_id: customer,
          user_id: salesPerson,
          saleInvoiceProduct,
          prefix: preInvoiceText,
          invoiceNumber: invoiceNum,
        };

        const resp = await dispatch(editSale(editInvoiceId, valueData, documentType));

        if (resp.message === "success") {
          form.resetFields();
          setFormData({});
          setAfterDiscount(0);
          setLoader(false);

          dispatch(
            loadAllSale({
              page: 1,
              limit: 1000,
              startdate: moment().startOf("month"),
              enddate: moment().endOf("month"),
              user: "",
            })
          );

          setTimeout(() => {
            navigate("/salelist");
          }, 100);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        toast.error("Error while updating");
      }
    };

    if (documentType !== "sale") {
      setLoader(true);
      await runSave();
      return;
    }

    await confirmMasterListPriceSyncThen(
      selectedProds,
      async () => {
        setLoader(true);
        await runSave();
      },
      { cancelText: "No, save invoice only" }
    );
  };

  const updateFormData = () => {
    const data = form.getFieldsValue();

    const total = data.saleInvoiceProduct?.reduce((acc, p) => {
      const {
        product_quantity = 0,
        product_sale_price = 0,
        product_sale_conversion = 0,
        product_sale_discount = 0,
      } = p;
      acc += product_quantity * product_sale_price * product_sale_conversion;
      return acc;
    }, 0);

    const productDiscount = data.saleInvoiceProduct?.reduce((acc, p) => {
      const { product_sale_discount = 0, product_quantity = 0 } = p;
      console.log("product_sale_discount", product_sale_discount);
      acc += product_sale_discount * product_quantity;
      return acc;
    }, 0);

    data.total = total;
    data.productDiscount = productDiscount;
    // console.log("data.total", data.total)
    // console.log("data.productDiscount", data.productDiscount)
    data.due =
      total -
      (data.paid_amount ?? 0) -
      (data.discount ?? 0) -
      (data.productDiscount ?? 0);

    setFormData(data);
    if (data.discount) {
      setAfterDiscount(total - (data.discount ?? 0));
    }
    if (data.discount == 0) {
      setAfterDiscount(0);
    }
    if (data.productDiscount) {
      setAfterProductDiscount(total - (data.productDiscount ?? 0));
    }
    if (data.productDiscount == 0) {
      setAfterProductDiscount(0);
    }
  };

  // Select Supplier Function
  const onChange = async (values) => {
    updateFormData();
  };

  const onSearch = (value) => {};

  // Products Handlers

  const [selectedProds, setSelectedProds] = useState([]);

  const handleSelectedProds = (prodId, key) => {
    if (!allProducts || !Array.isArray(allProducts)) return;
    const foundProd = allProducts.find((item) => item.id === prodId);
    
    if (!foundProd) return;

    const existingIndex = selectedProds.findIndex(prod => prod.key === key);
    
    if (existingIndex !== -1) {
      // Update existing product
      const updatedSelectedProds = [...selectedProds];
      updatedSelectedProds[existingIndex] = {
        ...foundProd,
        key: key,
        selectedQty: 1,
        sale_disc: discount,
        reference_list_price: getReferenceListPriceFromProduct(foundProd),
      };
      setSelectedProds(updatedSelectedProds);
    } else {
      // Add new product
      setSelectedProds((prev) => [
        ...prev,
        {
          ...foundProd,
          key: key,
          selectedQty: 1,
          sale_disc: discount,
          reference_list_price: getReferenceListPriceFromProduct(foundProd),
        },
      ]);
    }
  };

  const handleSelectedProdsQty = (key, qty) => {
    const updatedSelectedProds = selectedProds.map((prod) => {
      if (prod.key === key) {
        return { ...prod, selectedQty: qty };
      }
      return prod;
    });
    setSelectedProds(updatedSelectedProds);
  };

  const handleSelectedProdsSalePrice = (key, salePrice) => {
    const updatedSelectedProds = selectedProds.map((prod) => {
      if (prod.key === key) {
        return { ...prod, sale_price: salePrice };
      }
      return prod;
    });
    setSelectedProds(updatedSelectedProds);
  };

  const handleSelectedProdsSaleDisc = (key, saleDisc) => {
    const updatedSelectedProds = selectedProds.map((prod) => {
      if (prod.key === key) {
        return { ...prod, sale_disc: saleDisc };
      }
      return prod;
    });
    setSelectedProds(updatedSelectedProds);
  };

  const handleSelectedProdsCurrency = (key, currencyId) => {
    const currency = allCurrencies?.find((c) => c.id === currencyId);
    const updatedSelectedProds = selectedProds.map((prod) => {
      if (prod.key === key) {
        return { ...prod, product_currency: currency };
      }
      return prod;
    });
    setSelectedProds(updatedSelectedProds);
  };

  const handleDeleteProd = (key) => {
    const updatedProds = selectedProds.filter((prod) => prod.key !== key);
    setSelectedProds(updatedProds);
  };

  // Calculate total product discount
  const calculateTotalProductDiscount = () => {
    return selectedProds.reduce((sum, prod) => {
      const itemTotal = prod.sale_price * prod.selectedQty * prod.product_currency.conversion;
      const itemDiscount = (itemTotal * (prod.sale_disc || 0)) / 100;
      return sum + itemDiscount;
    }, 0);
  };

  const handleDiscount = (discountAmount) => {
    const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
    const afterAdditionalDiscount = subtotalAfterProductDiscounts - discountAmount;
    const finalTotal = afterAdditionalDiscount + (roundOffEnabled ? roundOffAmount : 0);
    let dueAmount = finalTotal;
    if (totalDiscountPaidDue.paid > 0) {
      dueAmount = dueAmount - totalDiscountPaidDue.paid;
    }
    setTotalDiscountPaidDue((prev) => ({
      ...prev,
      discount: discountAmount,
      due: dueAmount,
      afterDiscount: finalTotal, // Include round off in afterDiscount
    }));
    setDiscountAmount(discountAmount);
    if (discountAmount === "" || discountAmount === 0) {
      setAdditionalDiscount("");
    } else if (subtotalAfterProductDiscounts > 0) {
      const discountPercent = (discountAmount / subtotalAfterProductDiscounts) * 100;
      setAdditionalDiscount(discountPercent.toFixed(2));
    }
  };

  const handlePercentageDiscount = (discountPercent) => {
    let additionalDiscountAmount = 0;
    if (discountPercent > 0) {
      const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
      additionalDiscountAmount = Math.round((subtotalAfterProductDiscounts * discountPercent) / 100 * 100) / 100;
    }
    setAdditionalDiscount(discountPercent);
    handleDiscount(additionalDiscountAmount);
  };

  const handlePaid = (paidAmount) => {
    // Calculate the final total including round off
    const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
    const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
    const finalTotal = afterAdditionalDiscount + (roundOffEnabled ? roundOffAmount : 0);
    const dueAmount = finalTotal - paidAmount;
    
    setTotalDiscountPaidDue((prev) => ({
      ...prev,
      paid: paidAmount,
      due: dueAmount,
      afterDiscount: finalTotal, // Update afterDiscount to include round off
    }));
  };

  const handleRoundOff = (enabled, amount = null) => {
    setRoundOffEnabled(enabled);
    if (enabled) {
      // If amount is not provided, calculate automatic round off
      let roundOffValue = amount;
      if (amount === null) {
        const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
        const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
        const roundedTotal = Math.round(afterAdditionalDiscount);
        roundOffValue = roundedTotal - afterAdditionalDiscount;
        // Round to 2 decimal places
        roundOffValue = Math.round(roundOffValue * 100) / 100;
      }

      setRoundOffAmount(roundOffValue);
      // Recalculate totals with round off
      const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
      const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
      const finalTotal = afterAdditionalDiscount + roundOffValue;
      let dueAmount = finalTotal - totalDiscountPaidDue.paid;

      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        afterDiscount: finalTotal,
        due: dueAmount,
      }));
    } else {
      setRoundOffAmount(0);
      // Recalculate totals without round off
      const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
      const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
      let dueAmount = afterAdditionalDiscount - totalDiscountPaidDue.paid;

      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        afterDiscount: afterAdditionalDiscount,
        due: dueAmount,
      }));
    }
  };

  useEffect(() => {
    if (selectedProds.length > 0) {
      let total = 0;
      let afterDiscount = 0;
      let due = 0;
      let productDiscount = 0;
      let afterProductDiscount = 0;
      let totalQty = 0;

      selectedProds.forEach((prod) => {
        total +=
          prod.sale_price * prod.selectedQty * prod.product_currency.conversion; // to calculate product wise total
        productDiscount +=
          prod.sale_price *
          prod.selectedQty *
          prod.product_currency.conversion *
          (prod.sale_disc / 100); // To calculate discount product wise
        afterProductDiscount = total - productDiscount;
        totalQty += prod.selectedQty;
      });

      if (totalDiscountPaidDue.discount > 0) {
        afterDiscount = afterProductDiscount - totalDiscountPaidDue.discount;
      } else afterDiscount = afterProductDiscount;

      // Add round off to final total
      const finalTotal = afterDiscount + (roundOffEnabled ? roundOffAmount : 0);

      if (totalDiscountPaidDue.paid > 0) {
        due = finalTotal - totalDiscountPaidDue.paid;
      } else due = finalTotal;

      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        total,
        afterDiscount: finalTotal, // Use finalTotal which includes round off
        due,
        afterProductDiscount,
        productDiscount,
        totalQty,
      }));
    }
  }, [selectedProds, totalDiscountPaidDue.paid, totalDiscountPaidDue.discount, roundOffEnabled, roundOffAmount]);

  const handleDiscountTypeChange = (value) => {
    setDiscountType(value);
  };
  return (
    <Card>
      {editInvoice && (
        <Form
          key={`${editInvoice.id}-${documentType}`}
          initialValues={{
            ...editInvoice,
            sales_person_id:
              editInvoice.user_id != null && editInvoice.user_id !== ""
                ? Number(editInvoice.user_id)
                : editInvoice.sales_person_id,
            customer_id:
              editInvoice.customer_id != null && editInvoice.customer_id !== ""
                ? Number(editInvoice.customer_id)
                : undefined,
          }}
          form={form}
          className="m-lg-4"
          name="dynamic_form_nest_item"
          onChange={onChange}
          onFinishFailed={() => {
            setLoader(false);
          }}
          layout="vertical"
          size="large"
          autoComplete="off"
        >
          <Row className="mr-top" gutter={[24, 24]}>
            <Col span={24} className="border rounded column-design">
              <Title
                level={4}
                className="text-center"
                style={{
                  backgroundColor: "#dadada",
                  padding: "10px",
                  margin: "0 !important",
                }}
              >
                {documentType === 'quotation' ? 'Edit Quotation' : 
                 documentType === 'challan' ? 'Edit Challan' : 
                 documentType === 'sales_order' ? 'Edit Sales Order' :
                 'Edit Invoice'}
              </Title>
            </Col>

            <Col span={24} lg={24}>
              <div className="d-flex justify-content-between ">
                <Form.Item label="Order Date">
                  <DatePicker
                    onChange={(value) => setOrderDate(value || null)}
                    value={orderDate}
                    style={{ marginBottom: "10px" }}
                    format="DD-MMM-YYYY"
                    placeholder="Order Date"
                  />
                </Form.Item>

                <Form.Item label="Order No.">
                  <Input
                    onChange={(e) => setOrderNum(e.target.value)}
                    defaultValue={editInvoice?.invoice_order_number}
                    //   fields={[{ name: "Name" }]}

                    style={{ marginBottom: "10px" }}
                    label="Order Number"
                    name="orderNum"
                    placeholder="Order Number"
                    rules={[
                      {
                        required: false,
                        message: "Please Enter Order No.!",
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label="Customer "
                  name="customer_id"
                  style={{ maxWidth: "250px" }}
                  rules={[
                    {
                      required: true,
                      message: "Please Select a Customer!",
                    },
                  ]}
                >
                  <Select
                    loading={!allCustomer}
                    showSearch
                    placeholder="Select a customer "
                    optionFilterProp="children"
                    onChange={(id) => setCustomer(id)}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {allCustomer &&
                      allCustomer.map((sup) => (
                        <Option key={sup.id} value={sup.id}>
                          {sup.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>

                <Form.Item 
                  label={
                    documentType === 'quotation' ? 'Quotation Date' : 
                    documentType === 'challan' ? 'Challan Date' : 
                    'Invoice Date'
                  } 
                  required
                >
                  <DatePicker
                    onChange={(value) => setDate(value || moment())}
                    value={date}
                    style={{ marginBottom: "10px" }}
                    format="DD-MMM-YYYY"
                    placeholder={
                      documentType === 'quotation' ? 'Quotation Date' :
                      documentType === 'challan' ? 'Challan Date' :
                      'Invoice Date'
                    }
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={24} lg={24}>
              <div className="d-flex justify-content-between">
                {/* Invoice Number Input Field */}
                <Form.Item 
                  label={
                    documentType === 'quotation' ? 'Quotation Number' : 
                    documentType === 'challan' ? 'Challan Number' : 
                    'Invoice Number'
                  } 
                  required
                >
                  <div style={{ display: "flex" }}>
                    <Input
                      onChange={(e) => setPreInvoiceText(e.target.value)}
                      defaultValue={preInvoiceText}
                      style={{
                        marginBottom: "10px",
                        borderRadius: "5px 0px 0px 5px !important",
                        width: "150px",
                      }}
                      label="Prefix"
                      name="prefix"
                      placeholder="Prefix"
                      rules={[
                        {
                          required: false,
                          message: "Pre Invoice Text",
                        },
                      ]}
                    />
                    <Input
                      onChange={(e) => setInvoiceNum(e.target.value)}
                      defaultValue={editInvoice?.invoice_number}
                      // defaultValue={1}
                      style={{
                        marginBottom: "10px",
                        borderRadius: "0px 5px 5px 0px !important",
                        width: "150px",
                      }}
                      label="invoiceNumber"
                      name="invoiceNumber"
                      placeholder={
                        documentType === 'quotation' ? 'Quotation Number' : 
                        documentType === 'challan' ? 'Challan Number' : 
                        'Invoice Number'
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Invoice Number!",
                        },
                      ]}
                    />
                  </div>
                </Form.Item>

                {/* Sales Person Input Field */}
                <Form.Item
                  label="Sales Person "
                  name="sales_person_id"
                  style={{ maxWidth: "250px" }}
                  rules={[
                    {
                      required: true,
                      message: "Please Select a sales person!",
                    },
                  ]}
                >
                  <Select
                    loading={!allStaff}
                    showSearch
                    placeholder="Select sales person "
                    optionFilterProp="children"
                    onChange={(id) => {
                      setSalesPerson(id);
                    }}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {allStaff &&
                      allStaff?.map((info) => (
                        <Option key={info.id} value={info.id}>
                          {info.username}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Set Discount">
                  <Radio.Group
                    value={discountType}
                    onChange={(e) => handleDiscountTypeChange(e.target.value)}
                  >
                    <Radio value="bill">Bill Discount</Radio>
                    <Radio value="item">Item Wise Discount</Radio>
                  </Radio.Group>
                  <br />
                  <br />
                  {discountType === "bill" && (
                    <Form.Item
                      name="billDiscount"
                      rules={[
                        {
                          required: true,
                          message: "Please input bill discount!",
                        },
                        {
                          validator: (_, value) => {
                            const floatValue = parseFloat(value);
                            if (
                              isNaN(floatValue) ||
                              floatValue < 0 ||
                              floatValue > 100
                            ) {
                              return Promise.reject(
                                "Discount must be a number between 0 and 100"
                              );
                            }
                            const decimalPlaces = floatValue
                              .toString()
                              .split(".")[1];
                            if (decimalPlaces && decimalPlaces.length > 2) {
                              return Promise.reject(
                                "Discount can have maximum 2 decimal places"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      visible={discountType === "bill"}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <InputNumber
                          placeholder="Enter bill discount"
                          style={{ width: "85%" }}
                          onChange={(value) => setDiscount(value)}
                          disabled={discountType !== "bill"}
                        />
                        <h3 style={{ margin: "0 0 0 10px" }}>%</h3>
                      </div>
                    </Form.Item>
                  )}
                </Form.Item>
              </div>
            </Col>

            <Col span={24} lg={24}>
              <Products
                formData={formData}
                setData={setFormData}
                allProducts={allProducts}
                selectedProds={selectedProds}
                handleSelectedProds={handleSelectedProds}
                handleSelectedProdsQty={handleSelectedProdsQty}
                handleSelectedProdsSalePrice={handleSelectedProdsSalePrice}
                handleDeleteProd={handleDeleteProd}
                handleSelectedProdsSaleDisc={handleSelectedProdsSaleDisc}
                handleSelectedProdsCurrency={handleSelectedProdsCurrency}
              />
            </Col>

            <Col span={24} lg={16}></Col>
            <Col span={24} lg={8}>
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                }}
              >
                <strong>Total: </strong>
                <strong>Rs. {totalDiscountPaidDue.total}</strong>
              </div>

              {/* Total Product Discount */}
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                }}
              >
                <strong>Discount: </strong>
                <strong>Rs. {totalDiscountPaidDue.productDiscount}</strong>
              </div>

              {/* Total After Product Discount */}
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                }}
              >
                <strong>After Discount: </strong>
                <strong>Rs. {totalDiscountPaidDue.afterProductDiscount}</strong>
              </div>

              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                  alignItems: "center",
                }}
              >
                <div style={{ marginRight: "15px" }}>
                  <strong>Additional Discount: </strong>
                </div>
                <InputNumber
                  type="number"
                  placeholder="Amount"
                  addonBefore="Rs."
                  onChange={(value) => handleDiscount(value || 0)}
                  value={discountAmount}
                  style={{ width: "150px", marginRight: "10px" }}
                  precision={2}
                  step={0.01}
                />
                <InputNumber
                  type="number"
                  placeholder="%"
                  addonAfter="%"
                  onChange={(value) => handlePercentageDiscount(value || 0)}
                  value={additionalDiscount}
                  style={{ width: "120px" }}
                  precision={2}
                  step={0.01}
                />
              </div>

              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                }}
              >
                <strong>After Add. Discount: </strong>
                <strong>Rs. {totalDiscountPaidDue.afterDiscount}</strong>
              </div>

              {/* Round Off Section */}
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <strong>Round Off: </strong>
                  <Radio.Group
                    value={roundOffEnabled}
                    onChange={(e) => {
                      if (e.target.value === true) {
                        handleRoundOff(true, null); // Auto-calculate when enabling
                      } else {
                        handleRoundOff(false);
                      }
                    }}
                  >
                    <Radio value={true}>Enable</Radio>
                    <Radio value={false}>Disable</Radio>
                  </Radio.Group>
                </div>
                {roundOffEnabled && (
                  <InputNumber
                    type="number"
                    placeholder="Round Off Amount"
                    addonBefore="Rs."
                    onChange={(value) => handleRoundOff(true, value || 0)}
                    value={roundOffAmount}
                    style={{ width: "150px" }}
                    precision={2}
                    step={0.01}
                  />
                )}
              </div>

              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #ccc",
                }}
              >
                {documentType === 'sale' && (
                  <>
                    <strong>Paid Amount: </strong>
                    <Form.Item
                      name="paid_amount"
                      rules={[
                        {
                          required: true,
                          message: "Please input Paid amount!",
                        },
                      ]}
                    >
                      <InputNumber type="number" onChange={handlePaid} />
                    </Form.Item>
                  </>
                )}
              </div>
              {documentType === 'sale' && (
                <div
                  style={{
                    padding: "10px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    border: "1px solid #ccc",
                  }}
                >
                  <strong>Due Amount: </strong>
                  <strong>Rs. {totalDiscountPaidDue.due}</strong>
                </div>
              )}
              {/* Total Product Quantity */}
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                }}
              >
                <strong>Total Qty: </strong>
                <strong>{totalDiscountPaidDue.totalQty} Copies</strong>
              </div>

              <Form.Item style={{ marginTop: "15px" }}>
                <Button
                  block
                  type="primary"
                  htmlType="button"
                  loading={loader}
                  onClick={() => {
                    onFormSubmit();
                  }}
                >
                  Update Invoice
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Card>
  );
};

export default EditSale;
